module.exports = __webpack_public_path__ + "static/media/logo-neon.af463483.png";